
<template>
  <el-dialog class="order-dialog-wrap dialog-approve-reason" v-bind="dialogParam" :close-on-click-modal="false" v-dialogDragOnly custom-class="mini-dialog" append-to-body @close="funClose">
    <div class="dialog-loading-wrap" v-loading="dialogLoading">
      <el-form :model="approveFormData" ref="approveFormDom" label-width="70px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="reason" :label="dialogParam.placeholder">
              <el-input
                v-model="approveFormData.reason"
                size="small"
                type="textarea"
                :maxlength="200"
                :autosize="{ minRows: 3 }"
                :placeholder="$t('portal.qing-shu-ru-shen-pi-bei-zhu-200-zi-yi-nei',[dialogParam.placeholder])"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" :disabled="dialogLoading" @click="funConfirm">{{$t('portal.que-ren')}}</el-button>
        <el-button size="mini" @click="funCancel">{{$t('portal.qu-xiao')}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { translateI18n } from '~/common/utils/i18n-helper';
export default {
  name: 'dialogApproveReason',
  data() {
    return {
      closeType: '', // 关闭弹窗的类型
      defaultParam: { title: 'portal.ti-shi', placeholder: 'portal.shen-pi-bei-zhu' }, // 默认参数
      dialogParam: { visible: false }, // 实际参数
      dialogLoading: false,
      approveFormData: { reason: '' },
      placeholder: ''
    };
  },
  methods: {
    // 更新弹窗参数的方法，会在action.js的approvalReason方法中被调用，然后被自定义参数所更新
    updateDialogParam(newParam = {}) {
      this.dialogParam = Object.assign({}, { ...this.defaultParam }, newParam);
      this.dialogParam.title = translateI18n(this.dialogParam.title);
    },
    // 点击确认的事件
    funConfirm() {
      const dialogParam = this.dialogParam;
      this.closeType = '确认';
      // 在这里执行调用时写的确认回调
      if (typeof dialogParam.confirm === 'function') {
        dialogParam.confirm(this.approveFormData);
      }
      this.$refs.approveFormDom.resetFields();
      Object.assign(this.dialogParam, { visible: false });
    },
    // 点击取消的事件
    funCancel() {
      const dialogParam = this.dialogParam;
      this.closeType = '取消';
      // 在这里执行调用时写的关闭回调
      if (typeof dialogParam.close === 'function') {
        dialogParam.close();
      }
      this.$refs.approveFormDom.resetFields();
      Object.assign(this.dialogParam, { visible: false });
    },
    // 弹窗被关闭的事件，包括所有关闭场景：点击按钮的关闭、点击X的关闭和点击遮罩的关闭
    funClose() {
      if (this.closeType !== '') {
        return (this.closeType = '');
      }
      this.funCancel();
      this.closeType = '';
    }
  }
};
</script>

<style lang="less">
.dialog-approve-reason {
  .el-form-item {
    margin-bottom: 7px;
  }
  .el-form-item__label {
    line-height: 30px;
  }
  .el-dialog__body {
    padding: 15px 17px 18px;
  }
  .dialog-footer {
    .el-button {
      font-size: 13px;
    }
  }
}
</style>
